import { useState, useEffect } from 'react'; 

const useLocalStorage = (key, initialValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item !== null ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.error(`Error reading ${key} from localStorage:`, error);
      return initialValue;
    }
  });

  const setValue = (value) => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
      // Disparar evento personalizado para la misma pestaña
      window.dispatchEvent(new Event('local-storage'));
    } catch (error) {
      console.error(`Error setting ${key} in localStorage:`, error);
    }
  };

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === key || e.type === 'local-storage') {
        try {
          const newValue = window.localStorage.getItem(key);
          if (newValue !== JSON.stringify(storedValue)) {
            setStoredValue(newValue !== null ? JSON.parse(newValue) : initialValue);
          }
        } catch (error) {
          console.error(`Error parsing changed value for ${key}:`, error);
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('local-storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('local-storage', handleStorageChange);
    };
  }, [key, initialValue, storedValue]);

  return [storedValue, setValue];
};

export default useLocalStorage;